import { z } from 'zod';
import { nutritionSchema } from './canteen-operations.js';
export const canteenReportRangeSchema = z
    .object({
    startsOn: z.string().date(),
    endsOn: z.string().date(),
})
    .refine((value) => value.startsOn <= value.endsOn, {
    path: ['endsOn'],
    message: 'Data końcowa nie może być wcześniejsza od początkowej.',
});
const canteenReportTotalsSchema = z.object({
    reservedQuantity: z.number().int().nonnegative(),
    cancelledQuantity: z.number().int().nonnegative(),
    issuedQuantity: z.number().int().nonnegative(),
    remainingQuantity: z.number().int().nonnegative(),
    amountMinor: z.number().int().nonnegative(),
});
export const canteenReportBreakdownSchema = canteenReportTotalsSchema.extend({
    key: z.string().min(1),
    label: z.string().min(1),
});
export const canteenOperationalReportSchema = z.object({
    startsOn: z.string().date(),
    endsOn: z.string().date(),
    generatedAt: z.string().datetime({ offset: true }),
    currency: z.literal('PLN'),
    totals: canteenReportTotalsSchema,
    byDay: z.array(canteenReportBreakdownSchema),
    byMealType: z.array(canteenReportBreakdownSchema),
    menuItems: z
        .array(z.object({
        id: z.string().uuid(),
        serviceDate: z.string().date(),
        mealType: z.string().min(1),
        mealName: z.string().min(1),
        diet: z.string(),
        recipeVersionId: z.string().uuid().nullable(),
        allergens: z.array(z.string()),
        possibleAllergens: z.array(z.string()),
        nutrition: nutritionSchema,
    }))
        .default([]),
    details: z.array(z.object({
        id: z.string().uuid(),
        consumerId: z.string().uuid(),
        consumerDisplayName: z.string().min(1),
        serviceDate: z.string().date(),
        reservationState: z.string().min(1),
        mealType: z.string().min(1),
        mealName: z.string().min(1),
        reservedQuantity: z.number().int().nonnegative(),
        cancelledQuantity: z.number().int().nonnegative(),
        issuedQuantity: z.number().int().nonnegative(),
        amountMinor: z.number().int().nonnegative(),
    })),
});
export const canteenAuditEntrySchema = z.object({
    id: z.string().uuid(),
    action: z.string().min(1),
    summary: z.string().min(1),
    subjectType: z.string().min(1),
    subjectId: z.string().uuid(),
    actorId: z.string().uuid(),
    occurredAt: z.string().datetime({ offset: true }),
    details: z.record(z.string(), z.unknown()),
});
export const canteenAuditReportSchema = z.object({
    startsOn: z.string().date(),
    endsOn: z.string().date(),
    generatedAt: z.string().datetime({ offset: true }),
    entries: z.array(canteenAuditEntrySchema),
});
